export const staticTabsData = [
  {
    title: 'Basic',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685002877_salariedincome.png',
    link: 'www.cleartax.com',
    externalId: 'prod_itr_af_basic',
    rating: 4.9,
    startLink:
      '/s/pricing/?utm_ref=itr_2025_organic_landing_page_assisted_filing_salaried_income#expert-assisted-itr',
  },
  {
    title: 'Premium',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685035566_group18142180901.png',
    link: 'www.cleartax.com',
    externalId: 'prod_itr_af_premium',
    rating: 4.9,
    startLink:
      '/s/pricing/?utm_ref=itr_2025_organic_landing_page_assisted_filing_capital_gains#expert-assisted-itr',
  },
  {
    title: 'Elite',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685035733_group18142856.png',
    link: 'www.cleartax.com',
    externalId: 'prod_itr_af_black',
    rating: 4.9,
    startLink:
      '/s/pricing/?utm_ref=itr_2025_organic_landing_page_assisted_filing_foreign_income#expert-assisted-itr',
  },
  {
    title: 'Luxe',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685035831_group1814218044.png',
    link: 'www.cleartax.com',
    externalId: 'prod_itr_af_luxury',
    rating: 4.9,
    startLink:
      '/s/pricing/?utm_ref=itr_2025_organic_landing_page_assisted_filing_crypto#expert-assisted-itr',
  },
  {
    title: 'Ask an Expert',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685441674_group181447801.png',
    link: 'www.cleartax.com',
    externalId: 'prod_ask_expert_plan',
    rating: 4.9,
    startLink:
      '/s/pricing/?utm_ref=itr_2025_organic_landing_page_assisted_filing_self_employed_and_professional#expert-assisted-itr',
  },
];

export const salariedPlansList = [
  'prod_self_itr_1',
  'prod_self_itr_9',
  'prod_self_itr_10',
];
export const plansListCapitalGain = ['prod_self_itr_2', 'prod_self_itr_11'];
export const plansListNRI = ['prod_self_itr_6', 'prod_self_itr_12'];

export const ITR_ARTICLE_SCHEMA_TEMPLATE = {
  datePublished: '2023-06-09T12:57:48+05:30',
};

export const ITR_COMMIT_DATA_LINK = `https://api.github.com/repos/ClearTax/clear-frontier/commits?path=src/pages/cleartax.in/income-tax-efiling`;
